import { render, staticRenderFns } from "./datum.vue?vue&type=template&id=7352da9a&scoped=true&"
import script from "./datum.vue?vue&type=script&lang=js&"
export * from "./datum.vue?vue&type=script&lang=js&"
import style0 from "./datum.vue?vue&type=style&index=0&id=7352da9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7352da9a",
  null
  
)

export default component.exports